import { Component } from 'react';
import Checkbox from '@mui/material/Checkbox';
import { connect } from 'react-redux';
import { setOnlyValidationInProgressChecked } from '../../redux/analyseRisques/analyseRisquesActions'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader'
import './AnalyseRisquesFilters.css';

class AnalyseRisquesFilters extends Component {

    onValidationInProgressFilterChange(e, value){
        this.props.setOnlyValidationInProgressChecked(value, this.props.analysesRisques);
    }

    render() {
        let arOrPpsLabel = "analyses de risques";

        if(this.props.moduleSpp)
            arOrPpsLabel = "plans de prévention simplifié"

        return (
            <Card className="col-lg-12 col-md-12 col-sm-12 col-12 card card-filters">
                <CardHeader style={{ color: 'rgb(117, 117, 117)' }} title={"Filtres"} />
                <CardContent className={'without-padding'}>
                    <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-5 col-9 without-padding label-checkbox">
                            <span>{"Afficher seulement les " + arOrPpsLabel + " à renvoyer"}</span>
                        </div>
                        <div className="col-lg-2 col-md-3 col-sm-3 col-3 without-padding">
                            <Checkbox checked={this.props.onlyValidationInProgressChecked} className="small-checkbox" onChange={this.onValidationInProgressFilterChange.bind(this)}/>
                        </div>
                    </div>
                </CardContent>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        onlyValidationInProgressChecked: state.analysesRisques.onlyValidationInProgressChecked,
        analysesRisques: state.analysesRisques,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOnlyValidationInProgressChecked: (checked, analysesRisquesState) => dispatch(setOnlyValidationInProgressChecked(checked, analysesRisquesState)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AnalyseRisquesFilters);
